Views.add(new class extends AbstractView {

  constructor() {
    super({
      name: 'conversations',
      branch: 'conversations',
      depth: 0
    });
    this._scrollableSelector = "#slaask-widget-convpage-conversations";
  }

  onActive() {
    this.scrollToTop();
    Utils.restartAnimations(this.element);
  }

  mainTitle() {
    return Wording.window_title;
  }

  smallTitle() {
    return Wording.conversations_text;
  }

  initEventListeners() {
    Dom.findById('widget', 'slaask-widget-convpage-button').addEventListener("click", () => {
      Conversations.clickOnCta();
    });

    const toggleClosedConvs = () => {
      const view = Views.getByName('conversations')._element;
      const closedEl = view.querySelector('.closed');
      const chevronEl = view.querySelector('.collapsing-chevron');
      closedEl.classList.toggle('hide-closed-convs');
      chevronEl.classList.toggle('hide-closed-convs');
      Utils.localStorage('hide-closed-convs', closedEl.classList.contains('hide-closed-convs'))
    };

    Views.getByName('conversations')._element.querySelector('.closed').addEventListener('click', toggleClosedConvs);
    Views.getByName('conversations')._element.querySelector('.collapsing-chevron').addEventListener('click', toggleClosedConvs);
  }

  _htmlBase() {
    return `
      <div class="slaask-widget-convpage-conversations" id="slaask-widget-convpage-conversations">
        <div class="open" data-text="${Wording.list_open_conversations}"></div>
        <i class="collapsing-chevron ${Utils.localStorage('hide-closed-convs') ? 'hide-closed-convs' : ''}">${Svg.chevronRight('#888da8', '18px')}</i>
        <div class="closed ${Utils.localStorage('hide-closed-convs') ? 'hide-closed-convs' : ''}" data-text="${Wording.list_closed_conversations}"></div>
      </div>
      <div class="slaask-widget-convpage-buttons asktech-get-started">
        <button class="asktech-get-started-button" id="slaask-widget-convpage-button" style="background-color: ${this.app._window_color}; color: ${this.app._title_color}">${Wording.new_conversation_text}</button>
      </div>`;
  }

});
